var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentProjection',{attrs:{"type":"service","headline":_vm.name,"page-content":_vm.catalogPageContent,"show-in-this-language":_vm.showInThisLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }